import React, { Component } from 'react';
import _ from 'lodash';

import '../styles/WorkoutStats.css';
import lineGraph from '../assets/icons8-combo-chart-40.png';
import barbell from '../assets/icons8-dumbbell-40.png'

const colorSet = [
  '#98ccfd', '#2ecc71', '#f1c40f', '#e74c3c', '#98ccfd'
]

const addVals = (obj) => {
  let starter = 0;
  _.flatMap(obj, (val) => {
    starter += val; 
  });

  return starter;
}

class WorkoutStats extends Component {
  constructor(props){
    super(props);

    this.state = {
      stats: 3
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps.workoutObj.movement_stats);
  }

  render() {
    if(!this.props.workoutObj) return(
      <div className="no-left-border h-100">
        <h2>No workouts for selected tracks!</h2>
      </div>
    );

    if(!this.props.workoutObj.title && !this.props.workoutObj.workout_name) return(
      <div className="no-left-border h-100">
        <h2 className="mt4">No workouts for selected tracks!</h2>
      </div>
    );
      
    return(
      <div className="h-100">
        <div className="workout-half relative ph3 tl h-50">
          <div className="title-hack absolute top--1 left-0 flex justify-center items-center w-100">
            <img className="white mt2 pl2 pr2" height="32" width="32" src={barbell} />
            <h4 className="mt2 mb0 pl2 pr2 white b roboto"> 
              WOD{this.props.amountOfWorkouts > 1  
                ? ('s ' + (this.props.workoutIdx + 1) + '/' + this.props.amountOfWorkouts) 
                : ''}
            </h4>
          </div>
          <h2 className="title relative mt3 mb2 b">{this.props.workoutObj.title ? this.props.workoutObj.title : this.props.workoutObj.workout_name}</h2>
          {(this.props.workoutObj.workout_description) &&
            <div>
              {this.props.workoutObj.title && 
                <h4>{this.props.workoutObj.workout_name}</h4>
              }
              
              <div>
                {this.props.workoutObj.workout_description.split('\n').map((row, idx) =>
                  <p className="mv0" key={idx}>{row}</p>
                )}
              </div>
            </div>
          }
          {(this.props.workoutObj.notes) &&
            <div>
              {this.props.workoutObj.title && 
                <h4>{this.props.workoutObj.workout_name}</h4>
              }
              <div>
                {this.props.workoutObj.notes.split('\n').map((row, idx) =>
                  <p className="mv0" key={idx}>{row}</p>
                )}
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default WorkoutStats;


// WEBPACK FOOTER //
// ./src/components/WorkoutStats.js